export default __webpack_public_path__ + "static/media/wisetack_big.fb8bb689.svg";